export const getMapBoxBounds = points => {
  if (!points.length) return;

  // Calculate bounds
  const lats = points.map(p => p.latitude);
  const lngs = points.map(p => p.longitude);
  const sw = [Math.min(...lngs), Math.min(...lats)];
  const ne = [Math.max(...lngs), Math.max(...lats)];

  return [sw, ne];
};
